// @ts-expect-error
import 'swiper/css/pagination'
import { useRef } from 'react'
import { isEmpty } from 'remeda'
import { Navigation, Pagination, type Swiper } from 'swiper'
import { SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { Button } from '../Button/Button'
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ButtonContainer,
  Card,
  Image,
  Layout,
  NavigationButton,
  Slider,
} from './CollectionFocusBlock.styles'
import type { CollectionFocusBlockProps } from './CollectionFocusBlock.types'

export const CollectionFocusBlock = ({
  slides,
}: CollectionFocusBlockProps): JSX.Element | null => {
  const isDesktop = useMediaQuery('(min-width: 992px)')
  const swiperRef = useRef<Swiper>()

  if (!slides || isEmpty(slides)) {
    return null
  }

  return (
    <Layout>
      {slides.length > 1 && (
        <NavigationButton
          className="left"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <ArrowLeftIcon />
        </NavigationButton>
      )}
      <Slider
        centeredSlides
        loop={slides.length > 1}
        navigation={slides.length > 1}
        modules={[Pagination, Navigation]}
        pagination={{
          clickable: true,
        }}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper
        }}
      >
        {slides.map(({ id, image, mobileImage, cta }) => {
          return (
            <SwiperSlide key={id}>
              <Card isSingleSlide={slides.length === 1}>
                {((isDesktop && image) ||
                  (!isDesktop && !mobileImage && image)) && (
                  <Image
                    lqip
                    lazyload
                    alt={image.alt}
                    sources={buildIntrinsicWidthSources({
                      src: image.src || '',
                    })}
                    imgSrc={setQueryParams(image.src, [
                      { name: 'width', value: '30' },
                    ])}
                  />
                )}
                {!isDesktop && mobileImage && (
                  <Image
                    lqip
                    lazyload
                    alt={mobileImage.alt}
                    sources={buildIntrinsicWidthSources({
                      src: mobileImage.src || '',
                    })}
                    imgSrc={setQueryParams(mobileImage.src, [
                      { name: 'width', value: '30' },
                    ])}
                  />
                )}
                <ButtonContainer>
                  <Button
                    fullWidth
                    as="a"
                    variant="ghostWhite"
                    href={cta.url}
                    text={cta.text}
                  />
                </ButtonContainer>
              </Card>
            </SwiperSlide>
          )
        })}
      </Slider>
      {slides.length > 1 && (
        <NavigationButton
          className="right"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <ArrowRightIcon />
        </NavigationButton>
      )}
    </Layout>
  )
}
